import { Fancybox } from "@fancyapps/ui";

export default function () {
  document.addEventListener('alpine:initialized', () => {
    Fancybox.bind("[data-fancybox]", {
      hideScrollbar: false,
    });
  });
}
